export default {
    edit: 'Edit',
    delete: 'Delete',
    deletion: {
        confirm: 'Yes, delete now',
        content: 'You are deleting the innovation project for all project-team members.',
        notice: 'Attention: This action cannot be undone.',
        success: 'The innovation project was successfully deleted.',
        title: 'Are you sure you want to delete the innovation project "{title}" ?'
    },
    deprecated: 'This innovation project contains macro-trends that are no longer part of the current Trendone trend universe.'
}
